import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-search-filters',
  templateUrl: './skeleton-search-filters.component.html',
  styleUrls: ['./skeleton-search-filters.component.scss']
})
export class SkeletonSearchFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
